module.exports = __webpack_public_path__ + "static/media/icono_performance.ee41cdf7.svg";